import { useNavigate } from "react-router-dom";
import checklistItem from "./../assets/images/checklistItem.svg";
import { useMemo, useCallback, useState } from "react";
import MoozikServices from "../services/http/MoozikServices";
import { MoonLoader } from "react-spinners";

function Offer({
  offername,
  rpid,
  validity,
  amount,
  nbtitle,
  data,
  hourlisten,
  id,
}) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const errState = useMemo(() => rpid.toLowerCase().includes("err"), [rpid]);

  const handlePayment = useCallback(async () => {
    if (!loading) {
      if (!errState) {
        try {
          setLoading(true);
          const register = await MoozikServices.registerOffer({
            rpid,
          });
          if (register.statuscode !== 200) {
            console.log("err");
            console.log("====================================");
          }
          navigate("/id", {
            state: {
              rpid,
              offername,
              amount,
            },
          });
        } catch (error) {
          console.log("error", JSON.stringify(error, null, 3));
          console.log("error", error);
          alert("Une erreur est survenue, veuillez réessayer plus tard.");
        } finally {
          setLoading(false);
        }
      }
    }
  }, [amount, errState, loading, navigate, offername, rpid]);

  return (
    <div className="relative w-[100%] mt-8 mb-8 h-[281px] z-10 text-center text-black flex items-center justify-center">
      <div className="absolute top-[0px] rounded-[13.36px] [background:#123274E5] w-[90%] h-[281px]" />
      <div className="absolute top-[110.5px] box-border w-[80%] h-px border-t-[1px] border-solid border-white" />
      <div
        className="absolute top-[221px] w-[80%] h-[35px] cursor-pointer text-sm"
        onClick={handlePayment}
      >
        <div className="relative top-[0px] w-[100%] h-[35px] flex items-center justify-center">
          <div
            className={`relative top-[0px] rounded-mid-5 w-[100%] h-[35px] flex items-center justify-center ${
              errState ? "bg-slate-400" : "bg-gold-200"
            }`}
          >
            {loading ? (
              <MoonLoader size={20} color="black" />
            ) : (
              <div className="absolute top-[7px] leading-[24px] uppercase font-semibold [background: #00377D] [color:#00377D]
">
                {`J'en profite`}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="absolute top-[25px] left-[10%] w-[140px] h-5 text-smi">
        <div className="absolute top-[0px] left-[0px] rounded-tl-none rounded-tr-mini rounded-br-mini rounded-bl-none [background:#5F99D2] w-[140px] h-5" />
        <div className="absolute top-[-2px] left-[10px] leading-[24px] uppercase font-medium text-white">
          {`${offername}`}
        </div>
      </div>

      <div className="absolute top-[135px] left-[10%] w-[80%] h-16 text-left text-white">
        <div className="absolute top-[0px] left-[0px] w-[100%] h-3">
          <div className="absolute top-[0px] left-[26px] leading-[24px]">
            Mi-Kiff Vazo
          </div>
          <div className="absolute top-[0px] right-[0px] leading-[24px] font-semibold text-gold-200">
            {hourlisten
              ? hourlisten
              : id === 0
              ? "0.1Go"
              : id === 1
              ? "0.65Go"
              : "2.5Go"}
          </div>
          <img
            className="absolute h-full w-[4.27%] top-[50%] right-[95.73%] max-w-full overflow-hidden max-h-full"
            alt=""
            src={checklistItem}
          />
        </div>
        <div className="absolute top-[26px] left-[0px] w-[100%] h-3">
          <div className="absolute top-[1px] left-[26px] leading-[24px]">
            Data
          </div>
          <div className="absolute top-[1px] right-[0px] leading-[24px] font-semibold text-gold-200">
            {data ? data : id === 0 ? "0.07Go" : id === 1 ? "0.4Go" : "1.5Go"}
          </div>
          <img
            className="absolute h-full w-[4.27%] top-[50%] right-[95.73%] bottom-[0%] left-[0%] max-w-full overflow-hidden max-h-full"
            alt=""
            src={checklistItem}
          />
        </div>
        <div className="absolute top-[52px] left-[0px] w-[100%] h-3">
          <div className="absolute top-[0px] left-[26px] leading-[24px]">
            Kadoa
          </div>
          <div className="absolute top-[0px] right-[0px] leading-[24px] font-semibold text-gold-200">
            {nbtitle
              ? nbtitle
              : id === 0
              ? "0.03Go"
              : id === 1
              ? "0.25Go"
              : "1Go"}
          </div>
          <img
            className="absolute h-full w-[4.27%] top-[50%] right-[95.73%] bottom-[0%] left-[0%] max-w-full overflow-hidden max-h-full"
            alt=""
            src={checklistItem}
          />
        </div>
      </div>
      <div className="absolute top-[64px] left-[10%] text-13xl leading-[24px] font-extrabold text-white">
        {`${amount} `}
        <sup>
          <span className="text-base font-semibold text-gold-200">{`Ar `}</span>
        </sup>
      </div>
    </div>
  );
}

export default Offer;

